module.exports = __webpack_public_path__ + "static/media/INV-0224 - Administrative Penalty Order - Samalie Nsubuga.d59bbb3d.pdf";